<template>
    <form class="box" :style="getImage" method="post" action="" enctype="multipart/form-data">
        <div id="drop-zone" :class="{ dragging: isDragging }"
            @dragover="dragover" @drop="drop" @dragleave="dragleave" @dragend="dragend">
            <div v-if="!isLoading" class="drop-zone-caption">Drop Here to Replace</div>
            <span v-if="!isLoading" class="btn btn-primary btn-file" style="position: relative">
                <button class="mdl-button">or CLICK HERE</button>
                <input @change="selectLocal" type="file" id="drop-zone-file" name="files[]" > <!-- multiple? -->
            </span>
            <div v-show="isLoading" style="font-size: 14px; color: white;">
                <div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div>
                <div style="margin-top: 5px;">LOADING...</div>
            </div>
        </div>
    </form>
</template>
<script>

import UploadTools from './UploadTools.js'

var dropzoneComponent;

export default{
    name: "DropzoneFirebase",
    data: () => ({
        isDragging: false,
        isLoading: false
        // bgImage: "fakecover.jpg"
    }),
    props: ['bgImage', 'folder', 'fileName'],
    computed: {
        getImage(){
            if(this.bgImage) return 'background-image: url(' + this.bgImage + ');';
            return 'background-image: none;';
        }
    },
    mounted() {
        componentHandler.upgradeDom();
    },
    watch:{
        bgImage(val){
            dropzoneComponent.isLoading = false;
        } 
    },
    created(){
        dropzoneComponent = this;
    },
    methods: {
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        selectLocal(e){
            e.preventDefault();
            var file = e.target.files[0];
            console.log(e);

            //We need to send dropped files to Server
            UploadTools.handleSingleFileUpload(file, this);
        },
        drop(e) {
            e.preventDefault();
            this.isDragging = false;
            var files = e.dataTransfer.files;
            //We need to send dropped files to Server
            UploadTools.handleSingleFileUpload(files[0], this);
        },
        dragleave(e) {
            e.preventDefault();
            this.isDragging = false;
        },
        dragend(e) {
            e.preventDefault();
            this.isDragging = false;
        }
    }
}



</script>
<style>
    .box{
        margin-top: 28.125%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }
    #dragandrophandler {
        border: 2px dotted #ffffff;
        width: 400px;
        color: #ffffff;
        text-align: left;
        vertical-align: middle;
        padding: 10px 10px 10px 10px;
        margin-bottom: 10px;
        font-size: 200%;
    }

    #drop-zone {
        height: 0;
        margin-top: -28.125%;
        text-align: center;
        padding: calc(28.125%) 0 calc(28.125%) 0;
        outline: 2px dashed #ffffff;
        outline-offset: -10px;
        -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
        transition: outline-offset .15s ease-in-out, background-color .15s linear;
        font-size: 1.25rem;
        background-color: rgba(90, 90, 90, 0.3);
        /* position: relative; */
        /* padding: 100px 20px; */
    }

    #drop-zone .mdl-button{
        opacity: 0.66;
        font-weight: bold;
    }
    
    #drop-zone:hover, #drop-zone.dragging{
      background-color: rgba(90, 90, 90, 0.6);
    } 

    .btn-file input[type=file] {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        cursor: pointer;
    }

    input[type=file] {
        display: block;
    }

    #drop-zone .drop-zone-caption {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 14px;
        opacity: 0.66;
    }
</style>


// WEBPACK FOOTER //
// DropzoneFirebase.vue?fe4154ca